import { mutatorAction } from 'satcheljs';
import type { FavoriteTreeData } from '../store/schema/FavoritesStore';
import favoritesStore from '../store/store';
import type { AccountKey } from 'owa-client-types';

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setFavoriteTreeData: (
    accountKey: AccountKey,
    favoriteTreeData: FavoriteTreeData
) => void = mutatorAction(
    'setFavoriteTreeData',
    (accountKey: AccountKey, favoriteTreeData: FavoriteTreeData): void => {
        favoritesStore().favoriteTreeData.set(accountKey, favoriteTreeData);
    }
);
